<div class="modal-header">
  <h5 class="modal-title">
    <i class="fab fa-airbnb"></i>
    Booking Alteration
  </h5>
  <button (click)="dialogRef.close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <table class="table table-striped">
    <tr>
      <td i18n>Type</td>
      <td>
        {{ alteration?.type }}
      </td>
    </tr>
    <tr>
      <td i18n>Status</td>
      <td>
        {{ alteration?.status }}
      </td>
    </tr>
    <tr>
      <td i18n>Inquiry ID</td>
      <td>
        {{ alteration?.inquiry_id }}
      </td>
    </tr>
    <tr>
      <td i18n>Guest</td>
      <td>{{ alteration?.guest_details?.name }} ({{ alteration?.guest_details?.email }})</td>
    </tr>
    <tr>
      <td i18n>Description</td>
      <td>{{ alteration?.description }}</td>
    </tr>
    <tr>
      <td i18n>Date</td>
      <td>{{ $safeNavigationMigration(alteration?.created) | epoch : 'YYYY-MM-DD HH:mm' }}</td>
    </tr>
  </table>
</div>
<div class="modal-footer">
  <div class="flex-fill"></div>
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i>
    Close
  </button>
  <ng-container *ngIf="isHostAlteration && isPending">
    <button
      (click)="onCancel()"
      type="button"
      matTooltip="Cancel the alteration"
      i18n-matTooltip
      [disabled]="isLoading"
      class="btn btn-outline-danger create-btn"
    >
      <i class="fal fa-ban"></i> Cancel
    </button>
  </ng-container>
  <ng-container *ngIf="isGuestAlteration && isPending">
    <button
      (click)="onDecline()"
      type="button"
      matTooltip="Decline the alteration"
      i18n-matTooltip
      [disabled]="isLoading"
      class="btn btn-secondary-danger create-btn"
    >
      <i class="fal fa-ban"></i> Decline
    </button>
    <button
      (click)="onAccept()"
      type="button"
      matTooltip="Accept the alteration"
      i18n-matTooltip
      [disabled]="isLoading"
      class="btn btn-secondary-success create-btn"
    >
      <i class="fal fa-check"></i> Accept
    </button>
  </ng-container>
</div>
